import React, { Component } from 'react'

export default class ScrollTrack extends Component {
  state = { amountscrolled: 0 }

  componentDidMount() {
    setTimeout(() => {
      this.getmeasurements()

      if (typeof window !== 'undefined') {
        window.addEventListener('resize', this.handleWindowResize)
        window.addEventListener('scroll', this.handleScroll)
      }
    }, 1000)
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.handleWindowResize)
      window.removeEventListener('scroll', this.handleScroll)
    }
  }

  handleWindowResize = () => {
    this.getmeasurements()
    requestAnimationFrame(this.amountscrolled)
  }

  handleScroll = () => {
    requestAnimationFrame(this.amountscrolled)
  }

  getmeasurements = () => {
    const winheight =
      window.innerHeight ||
      (document.documentElement || document.body).clientHeight

    const docheight = this.getDocHeight()
    this.trackLength = docheight - winheight
  }

  getDocHeight = () => {
    var D = document

    return Math.max(
      D.body.scrollHeight,
      D.documentElement.scrollHeight,
      D.body.offsetHeight,
      D.documentElement.offsetHeight,
      D.body.clientHeight,
      D.documentElement.clientHeight
    )
  }

  amountscrolled = () => {
    var scrollTop =
      window.pageYOffset ||
      (document.documentElement || document.body.parentNode || document.body)
        .scrollTop
    var pctScrolled = Math.floor((scrollTop / this.trackLength) * 100)
    this.setState({ amountscrolled: pctScrolled })
  }

  render() {
    return (
      <div
        className="Nav__ScrollTrack"
        style={{ width: `${this.state.amountscrolled}%` }}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/scroll-track/index.js